import clsx from 'clsx'

const Select = ({ value, defaultValue, options, onChange, className, disabled }) => {
  const isControlled = value !== undefined && value !== null
  return (
    <select
      className={clsx('max-w-full appearance-none focus:outline-none focus:ring-0', className, {
        'min-w-[100px] border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-3 py-1 pr-9 rounded-full shadow leading-tight text-sm font-sans': 
          !className
      })}
      {...(isControlled ? { value } : { defaultValue })}
      onChange={onChange}
      disabled={disabled}
    >
      {options.map(({ value, label, id, disabled }, i) => (
        <option key={id || i} value={value} disabled={disabled}>
          {label || value}
        </option>
      ))}
    </select>
  )
}


export default Select
